import React from "react";

export default () => {
  return (
    <React.Fragment>
      <rect x="70" y="20" rx="4" ry="4" width="200" height="4" />
      <rect x="400" y="20" rx="4" ry="4" width="50" height="4" />
      <rect x="70" y="35" rx="3" ry="3" width="380" height="4" />
      <circle cx="30" cy="30" r="20" />
    </React.Fragment>
  );
};
